import { render, staticRenderFns } from "./SpecialNewsList.vue?vue&type=template&id=7b1b6d4e&"
import script from "./SpecialNewsList.vue?vue&type=script&lang=js&"
export * from "./SpecialNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports